/* Maison Fermoir — vidéos du carrousel de l'accueil (11/10/2026, demande de Mika).
   Les vidéos restent EN PAUSE sur leur image d'aperçu (rien n'est chargé au premier écran) ;
   elles se lisent au SURVOL de la souris et s'arrêtent quand elle sort ; au doigt, le toucher
   du thème (deferred-media) suffit. Un bouton coupe ou rallume le son, coupé au départ :
   rallumer une vidéo coupe les autres.
   Vise les <deferred-media class="mf-video-survol"> posés par proteus/carrousel_videos.py. */
(function () {
  var survol = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var ICONE_COUPE = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path fill="currentColor" d="M3 9v6h4l5 5V4L7 9H3zm13.6 3 2.7-2.7-1.4-1.4-2.7 2.7-2.7-2.7-1.4 1.4 2.7 2.7-2.7 2.7 1.4 1.4 2.7-2.7 2.7 2.7 1.4-1.4-2.7-2.7z"/></svg>';
  var ICONE_SON = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path fill="currentColor" d="M3 9v6h4l5 5V4L7 9H3zm13.5 3A4.5 4.5 0 0 0 14 8v8a4.5 4.5 0 0 0 2.5-4zM14 3.2v2.1a7 7 0 0 1 0 13.4v2.1a9 9 0 0 0 0-17.6z"/></svg>';

  /* 19/10/2026 — libellés du bouton de son selon la langue de la page (version anglaise). */
  var EN = /^en\b/i.test(document.documentElement.lang || '');
  var ACTIVER = EN ? 'Turn sound on' : 'Activer le son';
  var COUPER = EN ? 'Mute' : 'Couper le son';

  function video(el) { return el.querySelector('video'); }

  function lire(el) {
    if (!el.getAttribute('data-media-loaded') && el.showDeferredMedia) {
      el.showDeferredMedia();
    } else if (el.playMedia) {
      el.playMedia();
      el.isPlaying = true;
      el.updatePlayPauseHint && el.updatePlayPauseHint(true);
    }
  }

  function arreter(el) {
    if (el.pauseMedia) {
      el.pauseMedia();
      el.isPlaying = false;
      el.updatePlayPauseHint && el.updatePlayPauseHint(false);
    }
  }

  function boutonSon(el, tous) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'mf-video-son';
    b.setAttribute('aria-label', ACTIVER);
    b.innerHTML = ICONE_COUPE;
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var v = video(el);
      var allumer = !v || v.muted;
      tous.forEach(function (autre) {
        var va = video(autre);
        if (va) va.muted = true;
        var ba = autre.querySelector('.mf-video-son');
        if (ba) { ba.innerHTML = ICONE_COUPE; ba.setAttribute('aria-label', ACTIVER); }
      });
      if (!allumer) return;
      lire(el);
      // La vidéo peut n'exister qu'après le chargement différé : on attend qu'elle soit là.
      var essais = 0;
      (function rallumer() {
        var vv = video(el);
        if (vv) {
          vv.muted = false;
          vv.play().catch(function () {});
          b.innerHTML = ICONE_SON;
          b.setAttribute('aria-label', COUPER);
        } else if (essais++ < 20) {
          setTimeout(rallumer, 50);
        }
      })();
    });
    el.appendChild(b);
  }

  function brancher() {
    var tous = Array.prototype.slice.call(document.querySelectorAll('deferred-media.mf-video-survol'));
    tous.forEach(function (el) {
      if (el.dataset.mfSurvol) return;
      el.dataset.mfSurvol = '1';
      boutonSon(el, tous);
      if (!survol) return;
      el.addEventListener('mouseenter', function () { lire(el); });
      el.addEventListener('mouseleave', function () { arreter(el); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', brancher);
  } else {
    brancher();
  }
  document.addEventListener('shopify:section:load', brancher);
})();
